<!-- eslint-disable max-len -->
<route>
{
  "meta": {
    "requireAdmin": true,
    "customSite": true
  }
}
</route>
<template>
  <div class="py-1">
    <div class="bg-white p-5 shadow m-2">
      <div>
        <div class="text-3xl font-bold inline-block">Select Product Type</div>
      </div>
      <div class="items-center mt-5">
        <div>
          <button
            type="submit"
            class="btn btn-primary text-lg mr-3"
            @click="$router.push(`${path}?type=Segment&name=Segment`)"
          >
            next
          </button>
          <div class="text-xl font-bold inline-block">Segment</div>
        </div>
        <!-- <div class="text-right">
          <button
            type="submit"
            class="btn btn-primary text-lg mr-3"
            @click="$router.push('${path}?type=Segment&name=Segment')"
          >
            next
          </button>
        </div> -->
      </div>
      <div class="items-center mt-5">
        <div>
          <button
            type="submit"
            class="btn btn-primary text-lg mr-3"
            @click="$router.push(`${path}?type=Series&name=Series`)"
          >
            next
          </button>
          <div class="text-xl font-bold inline-block">Series</div>
        </div>
      </div>
      <hr class="mt-5">
      <div class="items-center mt-5">
        <div>
          <button
            type="submit"
            class="btn btn-primary text-lg mr-3"
            @click="$router.push(`${path}?type=Self&name=Self-paced%20DM%20course`)"
          >
            next
          </button>
          <div class="text-xl font-bold inline-block">Self-paced
            <font-awesome-icon
              class="reaction text-blue-600"
              size="lg"
              :icon="['fab', 'twitter']"
              @click="$router.push(`/admin/products/${course._id}`)"
            /> DM course</div>
        </div>
      </div>
      <div class="items-center mt-5">
        <div>
          <button
            type="submit"
            class="btn btn-primary text-lg mr-3"
            @click="$router.push(`${path}?type=Daily&name=Daily%20Lessons%20via%20DM`)"
          >
            next
          </button>
          <div class="text-xl font-bold inline-block">Daily Lessons via
            <font-awesome-icon
              class="reaction text-blue-600"
              size="lg"
              :icon="['fab', 'twitter']"
              @click="$router.push(`/admin/products/${course._id}`)"
            /> DM</div>
        </div>
      </div>
      <hr class="mt-5">
      <div class="items-center mt-5">
        <div>
          <button
            type="submit"
            class="btn btn-primary text-lg mr-3"
            @click="$router.push(`${path}?type=Thread&name=Thread%20based%20Lessons`)"
          >
            next
          </button>
          <div class="text-xl font-bold inline-block">
            <font-awesome-icon
              class="reaction text-blue-600"
              size="lg"
              :icon="['fab', 'twitter']"
              @click="$router.push(`/admin/products/${course._id}`)"
            /> Thread based Lessons</div>
        </div>
      </div>
      <hr class="mt-5" v-if="userInfo.user && userInfo.user.role === 'SUPERADMIN'">
      <div class="items-center mt-5" v-if="userInfo.user && userInfo.user.role === 'SUPERADMIN'">
        <div>
          <button
            type="submit"
            class="btn btn-primary text-lg mr-3"
            @click="$router.push(`${path}?type=Twitter-Notif&name=Site%20with%20Twitter%20Notifications`)"
          >
            next
          </button>
          <div class="text-xl font-bold inline-block">Site with
            <font-awesome-icon
              class="reaction text-blue-600"
              size="lg"
              :icon="['fab', 'twitter']"
              @click="$router.push(`/admin/products/${course._id}`)"
            /> Twitter Notifications</div>
        </div>
      </div>
      <div class="items-center mt-5" v-if="userInfo.user && userInfo.user.role === 'SUPERADMIN'">
        <div>
          <button
            type="submit"
            class="btn btn-primary text-lg mr-3"
            @click="$router.push(`${path}?type=Twitter&name=Site%20with%20Twitter-based%20assignments`)"
          >
            next
          </button>
          <div class="text-xl font-bold inline-block">Site with
            <font-awesome-icon
              class="reaction text-blue-600"
              size="lg"
              :icon="['fab', 'twitter']"
              @click="$router.push(`/admin/products/${course._id}`)"
            /> Twitter-based assignments</div>
        </div>
      </div>
      <div class="items-center mt-5" v-if="userInfo.user && userInfo.user.role === 'SUPERADMIN'">
        <div>
          <button
            type="submit"
            class="btn btn-primary text-lg mr-3"
            @click="$router.push(`${path}?type=Mail-Notif&name=Site%20with%20E-Mail%20Notifications`)"
          >
            next
          </button>
          <div class="text-xl font-bold inline-block">Site with
            <font-awesome-icon
              class="reaction"
              size="lg"
              :icon="['fas', 'envelope']"
              @click="$router.push(`/admin/products/${course._id}`)"
            /> E-Mail Notifications</div>
        </div>
      </div>
      <div class="items-center mt-5" v-if="userInfo.user && userInfo.user.role === 'SUPERADMIN'">
        <div>
          <button
            type="submit"
            class="btn btn-primary text-lg mr-3"
            @click="$router.push(`${path}?type=Mail&name=Site%20with%20E-Mail%20assignments`)"
          >
            next
          </button>
          <div class="text-xl font-bold inline-block">Site with
            <font-awesome-icon
              class="reaction"
              size="lg"
              :icon="['fas', 'envelope']"
              @click="$router.push(`/admin/products/${course._id}`)"
            /> E-Mail assignments</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import adminAPI from '@/services/admin';
import axios from 'axios';
import moment from 'moment';
import courseAPI from '@/services/course';
import userInfo from '@/services/userInfo';
import store from '@/store';
import utils from '@/services/utils';

export default {
  name: 'types',
  layout: 'admin',
  store,
  data() {
    return {
      userInfo: [],
      title: '',
      description: '',
      Deliver: 'TWEET',
      price: '',
      maxStudents: '',
      linear: false,
      scheduled: false,
      Charge: false,
      PPP: false,
      publishDateTime: '',
      Limitstudent: false,
      frequency: '',
      Frequency: false,
      publish: true,
      Type: 'twitter',
      sharingtips: false,
      showBackground: false,
      showCheck: false,
      showFeedback: false,
      showParticipate: false,
      Enablehashtag: false,
      showTakeaway: false,
      AllowsubmissionviaDM: false,
      Threadseries: false,
      image: '',
      creatorId: '',
      path: '/admin/products/new',
      imagePreview:
        'https://res.cloudinary.com/implicit/image/upload/v1643873624/courses/defaultimage_gtfecl.jpg',
      img: 'defaultimage_gtfecl.jpg',
      hasSubmitted: false,
    };
  },
  computed: {
    user() {
      return store.state.user;
    },
  },
  async mounted() {
    this.userInfo = await userInfo.getUserInfo(this.user.uid);
    this.creatorId = this.$route.query.creatorId;
    if (this.creatorId) {
      this.path = `/admin/course-creators/${this.creatorId}/new`;
    }
  },
  methods: {
    onImageUpload(e) {
      if (e.target.files.length > 0) {
        [this.image] = e.target.files;
        const data = URL.createObjectURL(this.image);
        this.img = e.target.files[0].name;
        this.imagePreview = data;
      } else {
        this.img = '';
        this.imagePreview = '';
      }
    },
    async createCourse() {
      this.hasSubmitted = true;
      const publishDateTime = new Date(this.publishDateTime);
      if (
        this.imagePreview !== null &&
        (!this.scheduled || !Number.isNaN(publishDateTime.getTime()))
      ) {
        const cloudName = 'implicit';
        const formData = new FormData();
        formData.append('upload_preset', 'courses');
        formData.append('file', this.image);
        store.commit('toggleLoading', true);
        let payload = {
          title: this.title,
          description: this.description,
          userId: this.userInfo.user.userId,
          price: this.price === '' ? 0 : this.price,
          maxStudents: this.maxStudents,
          linear: this.linear,
          scheduled: this.scheduled,
          publishDateTime: this.scheduled
            ? publishDateTime.getTime()
            : moment().subtract(30, 'days').toDate(),
          Frequency: this.Frequency,
          frequency: this.Frequency ? this.frequency : '',
          publish: this.publish,
          currency: 'USD',
          purchaseParityEnabled: this.PPP,
          medium: this.Deliver,
          setStudentLimit: this.Limitstudent,
          sharingtips: this.sharingtips,
          Enablehashtag: this.Enablehashtag,
          Threadseries: this.Threadseries,
          showBackground: this.showBackground,
          showCheck: this.showCheck,
          showFeedback: this.showFeedback,
          showParticipate: this.showParticipate,
          showTakeaway: this.showTakeaway,
          AllowsubmissionviaDM: this.AllowsubmissionviaDM,
          type: this.Type,
        };
        if (this.image !== '') {
          await axios
            .post(
              `https://api.cloudinary.com/v1_1/${cloudName}/upload`,
              formData,
              {
                transformRequest: (data, headers) => {
                  // eslint-disable-next-line no-param-reassign
                  delete headers.common.Authorization;
                  return data;
                },
              },
            )
            .then((result) => {
              payload = { ...payload, image: result.data.secure_url };
            })
            .catch((e) => console.log(e));
        } else {
          payload = { ...payload, image: this.imagePreview };
        }
        courseAPI
          .createCourse(payload)
          .then(() => {
            store.commit('toggleLoading', false);
            this.$router.push('/admin/products/');
          })
          .catch((error) => {
            store.commit('toggleLoading', false);
            if (error.response.status === 401) {
              utils.setStatusMsg(
                this,
                'Unauthorized access, redirected to implicit',
              );
              this.$router.push({ path: '/' });
            }
            console.log({ error });
          });
      }
    },
  },
};
</script>

<style>
.top-right {
  top: 1.5rem;
  right: 4rem;
}
</style>
